<!DOCTYPE html>
<!--[if IE 8 ]><html class="ie" xmlns="http://www.w3.org/1999/xhtml" xml:lang="en-US" lang="en-US"> <![endif]-->
<!--[if (gte IE 9)|!(IE)]><!-->
<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en-US" lang="en-US">
<!--<![endif]-->

<head>


</head>

<body class="body popup-loader counter-scroll">

  <!-- wrapper -->
  <div id="wrapper">
    <!-- page-title -->
    <div class="page-title">
      <div class="tf-tsparticles">
        <div id="tsparticles1" data-color="#fff" data-line="#fff"></div>
      </div>
      <div class="tf-container">
        <div class="row">
          <div class="col-12">
            <div class="content">
              <h1 class="title">How to play</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-content">
      <div class="tf-container">
        <div class="row">
          <div class="col-12">
            <div class="content">
              <ul class="">
                <div>
                  <br><br>
                  <h2 class="title mb-6">Registration, Login & Account</h2>
                  <p>To join the game, the user must register by entering:<br /><br />
                    - valid email address<br />
                    - personal password<br /><br />
                    Then he/she will have to activate his/her account from the received verification email. After
                    logging in with the registered personal credentials the user will be able to start playing the game,
                    being able to see all personal information related to the game on the profile page.
                  </p>
                </div>
                <br><br>
                <h2 class="title mb-6">Game Participation</h2>

                <p>Users will be able to create their own ticket on the homepage at the "Play
                  Now" section.<br />
                  Each GoGo Money Maker play has a duration of 7 days where each player can create only one ticket,
                  consisting of 5 numbers between 01 and 90. The ticket created will be unique and cannot be
                  duplicated by any other user for the duration of the current play period. To ensure the uniqueness
                  of each ticket, they must differ by at least one number. In case of unintentional creation of an
                  existing ticket, the user will be prompted to change its numerical composition. The ticket created
                  and validated will not be replaceable or editable, will remain anonymous, and will not be associated
                  with the user account in any way. The user will own the ticket he/she created and they can be
                  recognized only by their numerical composition.<br />
                  To access voting, a ticket must first be created.<br />
                  Voting for a ticket will take place on the "Ticket" page where all tickets created during the
                  relevant game period will be listed. To identify a particular ticket, the user can take advantage of
                  the "Search" button at the top of the page. It will not be possible for the user to vote for the
                  ticket he/she created. They will be defined as effective based on the date and time of ticket
                  validation,
                  and the vote will have nominal value (1) equally to all other votes.<br />
                  Voting is and will remain anonymous for the duration of the game, so even in the event of a win or
                  after an unlimited amount of time, under no circumstances will any information about the accounts
                  that cast the votes be provided to anyone.</p>
                <br><br>

                <h2 class="title mb-6">Payment</h2>
                <p>Each GoGo Money Maker play (creation and voting) has an effective cost of €5
                  (five) USD to be paid on the GoGo Money Maker website in USDT currency only via Crypto Wallet.
                  The value match between Fiat currency and USDT currency shall be calculated at the time of
                  payment according to the official and updated quotes. GoGo Money Maker offers real-time verified
                  conversion. In case of a mismatch by default, the bet will not be validated. After creating and
                  voting tickets, to validate the bet, you need to make the payment via the crypto wallet linked to
                  your account. The payment will be verified via blockchain and the user will receive a confirmation
                  email including a summary. In case the transaction is not verified, for whatever reason, the user
                  will not be able to continue the current play. The wallet address linked to the user account must
                  necessarily match the one used for the payment. In case the user uses two different wallet
                  addresses, participation in the game will be suspended and he/she will be contacted by GoGo Money
                  Maker via email, in time for the current play, to provide the final wallet address. It will be
                  submitted for validation and if successful, the current play will be validated.<br />
                  The user who wins the Jackpot will receive payment to the wallet registered and used to participate
                  in the game. In case of winning, it will not be possible in any way, the transfer of funds to a
                  wallet other than the one used to pay for the current play. In the event that, at the time of
                  winning, the reported wallet address is no longer active, the winnings will be voided and the entire
                  jackpot made available for the next play.<br />
                  Users will be able to change their wallet address prior to a new play. It will be submitted for
                  validation and GoGo Money Maker will notify the outcome via email.<br />
                  If the user prefers to play using traditional currencies, they can play with a Credit/Debit Card and Paypal Account.
                </p>

                <br><br>
                <h2 class="title mb-6">Timing & Duration of the Game</h2>
                <p>Each GoGo Money Maker play will last 7 days and each play period will start at
                  7pm on every Wednesday, with time reference CET (Central European Time).The effective duration of each
                  play
                  is
                  therefore 168 hours, with no exceptions or exclusions. GoGo Money Maker will communicate any changes,
                  through its social channels, 12h in advance of the next play period.</p>
                <br><br>
                <h2 class="title mb-6">Jackpot & Winning</h2>

                <p>The winnings will be paid out in USDT currency and only to the winner's
                  validated and active wallet, within 24 hours after the close of the current play. The amount of the
                  jackpot declared in dollars and converted to USDT currency will be paid taking into account the
                  current value of Dollar and USDT currencies at the time of winning that GoGo Money Maker will
                  notify the winning user via email. In the event of a jackpot exceeding €20,000, GoGo Money Maker will
                  pay out the entire amount from different wallets and therefore in individual tranches, but always on
                  the winner's validated and active wallet address.<br />
                  The jackpot will consist of the amount equal to the specific useful dollar percentage of the
                  individual bets (€5) made by individual users, divided as follow:<br />
                <ul>
                  <li>40% for the winner</li>
                  <li>60% divided among the voters</li>
                </ul><br />
                At the end of each play, the jackpot will be reset to start the next play (7PM - CET).


                <br><br>
                <h2 class="title mb-6">Strategy</h2>
                <p>Users will be able to create teams, strategies, and manage the flow of votes.
                  GoGo Money Maker provides its social channels to allow users to manipulate the current jackpot
                  assignment based on strategic vote management. GoGo Money Maker encourages organization among users
                  to manage the flow of votes. The jackpot can be divided among multiple users after winning. It is
                  understood that split jackpots will, in all cases, be the responsibility of the users and the result
                  of structured strategies between them of which GoGo Money Maker is in no way aware. GoGo Money Maker
                  will only award the jackpot to the winner and any split thereof will be the sole responsibility of
                  the rightful assignee. It is irrelevant to GoGo Money Maker whether the same user wins periodically
                  and in an organized manner as the result of strategies agreed upon between users.</p>
                <br><br>
                <h2 class="title mb-6">Contact</h2>

                <p>GoGo Money Maker is available to users on the official social channels - <a
                    href="https://discord.gg/M8mApmMqKQ" target="_blank">Discord</a>.<br />
                  For support and assistance contact GoGo Money Maker at: <a href="mailto:support@gogomoneymaker.com"
                    target="_blank">support&#64;gogomoneymaker.com</a></p>

                <br><br>
                <h2 class="title mb-6">Steps</h2>

                <p>
                <ul>
                  <li>Register your account and log in</li>
                  <li>Choose your numbers. Create your ticket</li>
                  <li>Vote for a ticket. Assign your vote to another user's ticket</li>
                  <li>Make a payment</li>
                  <li>Put your strategy into practice</li>
                  <li>Wait until 7PM on Wednesday to find out if you have won</li>
                  <li>Cash in the Jackpot</li>
                </ul>


              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>

</html>